import { REGEX } from '@/helpers'

export default {
  props: {
    validate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentError: '',
    }
  },
  computed: {
    validationRegEx() {
      switch (this.name) {
        case 'code':
          return REGEX.SIX_DIGITS
        case 'email':
          return REGEX.EMAIL
        case 'group_size':
          return REGEX.TINY_INT
        case 'phone':
          return REGEX.PHONE
        default:
          return REGEX.TEXT
      }
    },
  },
  methods: {
    validateField(value) {
      if (this.validate) {
        if (this.required && !value) {
          return (this.currentError = this.$t('errors.empty').replace('[FIELD]', this.label))
        }
        if (this.options && !Object.keys(this.options).includes(value.toString())) {
          return (this.currentError = this.$t('errors.pattern').replace('[FIELD]', this.label))
        } else if (value && value !== '' && !this.validationRegEx.test(value)) {
          return (this.currentError = this.$t('errors.pattern').replace('[FIELD]', this.label))
        }

        return (this.currentError = '')
      }
    },
    valueChange(event) {
      if (this.validate) this.validateField(event.target.value)
      this.$emit('update:modelValue', {
        valid: this.currentError === '',
        value: event.target.value,
      })
    },
  },
}
